<template>
  <div>
    <el-row style="margin-bottom: 10px">
      <router-link
        :to="{
					name: 'idclist',
					params: {
						passCurrentPage:passedIdcPage
					}
				}">
        <span style="font-weight: bolder;font-size: 18px;color: black">IDC列表</span>
      </router-link>
      <span style="font-size: 18px;margin-left: 5px"> > </span>
      <span style="font-size: 18px;margin-right: 5px">设备管理</span>

      <el-input placeholder="搜索" clearable v-model="condition" style="width: 300px;margin-right:10px;float: right">
        <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
      </el-input>
    </el-row>
    <el-row>
      <el-col>
        <el-button type="primary" @click="adddevice"
                   v-if="btnInList('idc_device','idc_device_add')">新增设备
        </el-button>
        <el-button v-if="btnInList('idc_device','idc_device_import')">导入</el-button>
        <el-button v-if="btnInList('idc_device','idc_device_export')">导出</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="id" label="ID" width="180"></el-table-column>
      <el-table-column align="center" prop="deviceName" label="名称" width="180"></el-table-column>
      <el-table-column align="center" prop="idcName" label="IDC"></el-table-column>
      <el-table-column align="center" prop="createDate" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作" width="600">
        <template v-slot="{row}">
          <!--          <el-button size="mini" type="primary" @click="addInstance(row)"-->
          <!--                     v-if="btnInList('idc_device','idc_device_view')">-->
          <!--            &lt;!&ndash;            {{conventName(row)}}&ndash;&gt;-->
          <!--            查看-->
          <!--          </el-button>-->
          <el-button size="mini"
                     v-if="row.serviceAgentId && row.serviceAgentId!=0 && btnInList('idc_device','idc_device_agent_cat')"
                     type="primary"
                     @click="serviceAgentClick(row)">
            查看service_agent
          </el-button>
          <span v-else>
            <el-button size="mini" v-if="btnInList('idc_device','idc_device_agent_create')" type="primary"
                       @click="serviceAgentClick(row)">
            创建service_agent
          </el-button>
          </span>


          <el-tooltip content="升级service_agent" effect="light" placement="top">
            <el-button size="mini" v-if="row.serviceAgentId && btnInList('idc_device','idc_device_agent_upgrade')"
                       type="primary"
                       @click="upgradeInstance(row.serviceAgentId)">
              升级
            </el-button>
          </el-tooltip>
          <el-tooltip content="点击换绑service_agent" effect="light" placement="top">


            <el-dropdown trigger="click" @command="command => bindServiceAgentId(row, command)"
                         v-if="btnInList('idc_device','idc_device_bind')"
                         style="margin-left: 10px">
              <el-button size="mini" type="primary" @click="getInstanceList(row)"
              >
                {{ conventName(row) }}
              </el-button>
              <el-dropdown-menu slot="dropdown" style="width: 100px">
                <el-dropdown-item
                  :command="item" v-for="(item, index) in instanceIdList" :key="index">
                  <div>
                    {{ item }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>

          <div style="margin-top: 10px">
            <el-button size="mini" type="primary" @click="netcardman(row)"
                       v-if="btnInList('idc_device','idc_device_netcard')"
                       style="margin-left: 10px">网卡管理
            </el-button>
            <el-button size="mini" type="primary" @click="editDevice(row)"
                       v-if="btnInList('idc_device','idc_device_edit')">编辑
            </el-button>
            <el-button size="mini" type="danger" @click="delConfirm(row)"
                       v-if="btnInList('idc_device','idc_device_del')">删除
            </el-button>
            <el-button v-if="btnInList('idc_device','idc_device_offline')"
                       size="mini" type="danger" @click="offlineConfirm(row)">一键下线
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="deviceTitle"
      :visible="devadd"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="32%">
      <el-form label-position="left" style="margin-left: 25px" :model="formData" ref="formData" :rules="rules">
        <el-form-item label="设备名称" prop="deviceName" label-width="100px">
          <el-input v-model="formData.deviceName" placeholder="请输入内容" style="width: 230px"></el-input>
        </el-form-item>
        <el-form-item label="备 注" prop="remark" label-width="100px">
          <el-input v-model="formData.remark" placeholder="请输入内容" style="width: 230px"></el-input>
        </el-form-item>
        <el-form-item prop="alarmEnable" label="是否启用微信告警">
          <el-radio-group v-model="formData.alarmEnable">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="frequency" label-width="100px" v-if="formData.alarmEnable==1">
          <span slot="label">
			<el-tooltip effect="dark" content="守护进程向管理中心汇报的频率" placement="top">
				<i class="el-icon-question"></i>
			</el-tooltip>
			<span>频率</span>
          </span>
          <el-button type="primary" size="mini" style="margin-right: 10px" @click="reduce">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-input v-model="formData.frequency" placeholder="" style="width: 60px;"></el-input>

          <el-button type="primary" size="mini" style="margin-left: 10px;margin-right: 10px" @click="plus">
            <i class="el-icon-plus"></i>
          </el-button>
          <span>秒/次</span>
        </el-form-item>
        <el-form-item prop="sucRate" label-width="100px" v-if="formData.alarmEnable==true">
          <span slot="label">
			<el-tooltip effect="dark" content="实际接收次数/理论接收次数" placement="top">
				<i class="el-icon-question"></i>
			</el-tooltip>
			<span>接收成功率</span>
          </span>
          <el-input v-model="formData.sucRate" placeholder="请输入" style="width: 100px"></el-input>
        </el-form-item>

        <el-row style="text-align: center;">
          <el-button type="primary" @click="saveDevice()">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <Card-manager v-if="showEdit" :visible="showEdit"
                  :idcId="idcId"
                  :deviceInfo="deviceInfo" @editCallback="editCallback"/>


    <el-dialog
      title="提示"
      :visible="tipVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px">
      您正在进行一键删除操作 <span style="font-style: italic;color: #7b7878">(&nbsp;删除设备以及释放设备资源&nbsp;)</span> ，请在输入框内输入"<span
      style="color: red;font-weight: bold">立即删除</span>"进行确认。
      <el-input v-model="offlineInput" placeholder="请输入内容" style="margin-top: 20px"></el-input>
      <div style="text-align: center;margin-top: 15px">
        <el-button type="primary" size="small" @click="saveOffline">确 认</el-button>
        <el-button size="small" @click="tipVisible=false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible="tipStreamVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false" @close="close"
      width="600px">
      <div v-html="tipStream" style="margin-left: 20px"></div>
    </el-dialog>
  </div>
</template>

<script>
import CardManager from '../CardManager.vue'
import {mapMutations, mapState} from "vuex";

export default {
  components: {CardManager},
  name: "DeviceList",
  data() {
    var frequencyValidate = (rule, value, callback) => {
      const reg = /^[0-9]*[1-9][0-9]*$/;
      if (!reg.test(value)) {
        callback(new Error('只能输入正整数！'))
      }
      if (value < 1 || value > 300) {
        callback(new Error('请输入1-300内的正整数'))
      } else {
        callback()
      }
    };
    var sucRateValidate = (rule, value, callback) => {
      if (value < 1 || value > 100) {
        callback(new Error('请输入1-100内的正整数'))
      } else {
        callback()
      }
    };
    return {
      rules: {
        deviceName: [
          {required: true, message: '必填项', trigger: 'blur'}
        ],
        alarmEnable: [
          {required: true, message: '必填项', trigger: 'blur'}
        ],
        frequency: [
          {validator: frequencyValidate, message: '请输入1-300内的正整数', trigger: 'blur'}
        ],
        sucRate: [
          {validator: sucRateValidate, message: '请输入1-100内的正整数', trigger: 'blur'}
        ],
      },
      offlineInput: "",
      offlineId: "",
      tipStream: "",
      tipVisible: false,
      tipStreamVisible: false,
      currentDeviceId: "",
      condition: "",
      deviceTitle: "",
      passedIdcPage: "",
      newbindServiceAgentId: "",
      id: null,
      idcId: 0,
      deviceInfo: {},
      devadd: false, //新增窗口
      showEdit: false,
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      instanceIdList: [],
      tableData: [],
      formData: {
        alarmEnable: null,
        frequency: 50,
        sucRate: 80,
        deviceName: "",
        remark: "",
        id: "",
      }
    }
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否可以显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (btn && btn.length > 0) {
          if (!childName) {
            return btn.length > 0
          } else {
            return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
          }
        }
      }
    },
  },
  methods: {
    ...mapMutations(['getListOperations']),
    close() {
      this.tipStreamVisible = false;
      this.initDeviceList();
    },
    searchClick() {
      this.currentPage = 1;
      this.initDeviceList()
    },
    offlineConfirm(row) {
      this.offlineInput = "";
      this.tipVisible = true;
      this.offlineId = row.id
    },
    saveOffline() {
      if (this.offlineInput == "立即删除") {
        this.offline();
        this.tipVisible = false;
        this.tipStreamVisible = true;
      } else {
        this.offlineInput = ""
        this.$message.error("校验失败，请重新输入！")
      }
    },
    offline() {
      this.tipStream = ""
      fetch(this.baseUrl3 + "management3/device/release", {
        method: 'POST',
        body: JSON.stringify({deviceId: this.offlineId}),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
        .then(response => {
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let result = '';

          const read = () => {
            return reader.read().then(({done, value}) => {
              if (done) {

                return
                // when done is true, all data has been received
                // console.log('Received data:', result);
              } else {
                this.tipStream += decoder.decode(value);
                console.log(this.tipStream)
                return read();
              }
            });
          };

          return read();
        })
        .catch(error => {
          console.error('Error:', error);
        });
//       let data={
//         deviceId:this.offlineId
//       }
//       this.$axios.post(this.baseUrl3 + "management3/device/release",data,
//         { responseType: "text" })
//         .then(({data: {msg, data, code}}) => {

//           this.tipStream=data;
//         }).catch(err => {
//       })
    },
    reduce() {
      if (this.formData.frequency > 1 && this.formData.frequency < 300) {
        this.formData.frequency = this.formData.frequency - 1;
      } else {
        this.$message.error('输入频率范围为1-300')
      }
    },
    plus() {
      if (this.formData.frequency > 1 && this.formData.frequency < 300) {
        this.formData.frequency = parseInt(this.formData.frequency) + 1;
      } else {
        this.$message.error('输入频率范围为1-300')
      }
    },
    conventName(row) {
      if (row.serviceAgentId) {
        // if (this.newbindServiceAgentId) {
        //   if (row.serviceAgentId != this.newbindServiceAgentId) {
        //     return "已绑定Service-Agent:" + this.newbindServiceAgentId;
        //   }else {
        //   }
        // } else {
        return "已绑定Service-Agent:" + row.serviceAgentId;
        // }
      } else {
        return "绑定Service-Agent"
      }
    },
    adddevice() {
      this.id = null;
      this.deviceTitle = "新增设备";
      this.formData.deviceName = "";
      this.formData.remark = "";
      this.formData.alarmEnable = 0;
      this.formData.frequency = 50;
      this.formData.sucRate = 80;
      this.formData.remark = "";
      this.devadd = true
    },
    resetForm() {
      this.devadd = false
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initDeviceList()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initDeviceList()
    },
    netcardman(row) {
      this.id = row.id;
      this.deviceInfo = row;
      this.showEdit = true
    },
    serviceAgentClick(row) {
        if (row.serviceAgentId && row.serviceAgentId!=0) {
          this.$router.push({
            name: 'deployinstancelist',
            params: {
              currentPage: 1,
              serviceAgentId: this.newbindServiceAgentId ? this.newbindServiceAgentId : row.serviceAgentId,
              bsType: "device",
              idcId: this.idcId
            }
          })
        } else {
          this.$router.push({
            name: "deployinstance",
            query: {
              deviceId: row.id,
              idcId: this.idcId,
              p: 'idc'
            }
          });
        }


    },
    findInstanceById(serviceAgentId) {
      this.$axios.get(this.baseUrl3 + "instance/findById/" + serviceAgentId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$router.push({
              name: "deployinstancemoduleupdate",
              params: {
                id: data.id, //实例id
                serviceName: data.service.name, //服务名称
                moduleType: data.moduleType, // 模块类型
                moduleVersion: data.moduleVersion, // 模块版本
                unitAlias: data.integrationVersionAlias, //集成别名
                unitVersion: data.integrationVersionVersion, //集成版本
                resourceId: data.resource ? data.resource.id : "",
                deviceId: data.deviceId,
                editDep: data.editDep, //是否已经建立过依赖
                currentPage: 1, //当前的页码
                idcFlag: true,
                idcId: this.idcId
              }
            });
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
      })

    },
    bindServiceAgentId(row, id) {
      this.bind(row, id);
    },
    bind(row, serviceAgentId) {
      let model = {
        deviceId: this.currentDeviceId,
        serviceAgentId: serviceAgentId
      };
      this.$axios.post(this.baseUrl3 + 'management3/device/bind', model)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            // this.newbindServiceAgentId = serviceAgentId;
            row.serviceAgentId = serviceAgentId;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getInstanceList(row) {
      this.currentDeviceId = row.id;
      this.$axios.get(this.baseUrl3 + "management3/instance/list/service_agent/" + row.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.instanceIdList = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
      })

    },
    upgradeInstance(serviceAgentId) {
      this.findInstanceById(serviceAgentId)
    },
    editCallback() {
      this.showEdit = false
    },
    editDevice(item) {
      this.id = item.id;
      this.formData.deviceName = item.deviceName;
      this.formData.remark = item.remark;
      this.formData.frequency = item.frequency;
      this.formData.alarmEnable = item.alarmEnable;
      this.formData.sucRate = item.sucRate;
      this.deviceTitle = "编辑设备";
      this.devadd = true
    },
    delConfirm(row) {
      this.$confirm('您确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delDevicec(row.id)
      }).catch(() => {

      });
    },
    delDevicec(id) {
      let data = {
        id: id
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/device/del', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.initDeviceList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    initDeviceList() {
      var data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        'condition': this.condition,
        'createDate': this.createDate,
        'idcId': this.idcId
      };
      let _this = this;

      _this.tableData = [];
      //_this.totalElement = 0
      this.$axios.post(this.baseUrl3 + 'management3/device/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.tableData = data.deviceList;
            _this.totalElement = data.total
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveDevice() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          let data = {
            deviceName: this.formData.deviceName,
            remark: this.formData.remark,
            idcId: this.idcId,
            id: this.id,
            alarmEnable: this.formData.alarmEnable,
            sucRate: parseInt(this.formData.sucRate),
            frequency: parseInt(this.formData.frequency)
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            // spinner: 'el-icon-loading',
            background: 'rgba(55,55,55,0.4)'
          });
          let _this = this;
          this.$axios.post(this.baseUrl3 + 'management3/device/update', data)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                _this.initDeviceList();
                _this.devadd = false;
                _this.$message.success("操作成功！");
              } else {
                _this.$message({showClose: true, message: msg, type: 'error'})
                console.log(msg)
              }
              // setTimeout(() => {
              //   loading.close();
              // }, 1000);
              loading.close();
            })
            .catch(err => {
              console.log(err);
              setTimeout(() => {
                loading.close();
              }, 2000);
            })
        }
      })

    }
  },

  created() {
    this.getListOperations('idclist');
    if (!this.currentMenu) {
      return
    }
    this.idcId = parseInt(this.$route.params.idcId);
    this.passedIdcPage = parseInt(this.$route.params.passIdcPage);

    this.initDeviceList()
  }
}
</script>

<style scoped>
.navcss {
  font-size: 17px;
  margin-bottom: 15px;
}

.el-loading-spinner {
  background-image: url('../../../assets/loading1.svg');
  background-size: 63px 100px;
  background-repeat: no-repeat;
  height: 30%;
  background-position: center;
  top: 200px;
}

.el-loading-spinner .circular {
  display: none;
}

.el-loading-spinner .el-loading-text {
  margin-top: 150px;
  text-align: center;
}
</style>
